import { useMutation } from '@tanstack/react-query';
import { registerApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const useRegister = () => {
  const { onRegisterSuccess } = useAuth();
  const { error: toastError } = useToast();

  return useMutation({
    mutationFn: registerApi,
    onSuccess: (data, variables) => {
      onRegisterSuccess({ ...data, email: data?.email || variables.email });
    },
    onError: (err) => {
      toastError(err?.message || 'Registration failed. Please try again.');
    },
  });
};

export default useRegister;
